
export class BaseCompleteRequest{
    userID: number;
    status: string;
    notes: string;
    attachments: File[];
}

export class ProgramCompleteRequest extends BaseCompleteRequest {
    programIDs: number[] = [];
    statusId: number;
}
export class CourseCompleteRequest extends BaseCompleteRequest {
    courseIDs: number[] = [];
    statusId: number;
    programId: number;
}
export class TopicCompleteRequest extends BaseCompleteRequest {
    referenceTopicIDs:number[] = [];
    statusId: number;
    programId: number;
}

export  class ProgramBulkRequest {
    programIds : number[] = [];
}

export class File
{
    name:string;
    file:string;
}
